import { render } from "./BackToLogin.vue?vue&type=template&id=13d86fb1&scoped=true"
import script from "./BackToLogin.vue?vue&type=script&lang=js"
export * from "./BackToLogin.vue?vue&type=script&lang=js"

import "./BackToLogin.vue?vue&type=style&index=0&id=13d86fb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d86fb1"]])

export default __exports__